// extracted by mini-css-extract-plugin
export default {"root":"_7HnRh","img":"eCBIN"};